<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="AtomicRanchBook_0002_001" id="d14e40" src="images/AtomicRanchBook_0002_001.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Grin_ISBN9781423600022_epub_c2_r1.vue?4abe53de